import { useFormState } from 'react-hook-form'
import { useBlockAction } from '@editorHooks'
import { RESULTS2_DESIGN_FORM_BLOCK_ACTION } from '../constants'
import type { DesignFormRootValues } from '../types'

/**
 * Registers a block for {@link RESULTS2_DESIGN_FORM_BLOCK_ACTION} while the Bemessung (design) form
 * has unsaved changes, so subscribers (element selection, tab/pane switches, the scene, the left
 * sidebar) can stop navigation until the form is saved. Renders nothing; must live inside the form.
 *
 * Uses `dirtyFields` (not `formState.isDirty`) as the source of truth: "Rückgängig" resets with
 * `keepDirty: false`, which clears `dirtyFields` but can leave `formState.isDirty` stuck true.
 */
export const DesignFormDirtyBlocker = (): null => {
  const { dirtyFields } = useFormState<DesignFormRootValues>()
  const hasUnsavedChanges = Object.keys(dirtyFields).length > 0

  useBlockAction(RESULTS2_DESIGN_FORM_BLOCK_ACTION, hasUnsavedChanges ? 'provider' : undefined)

  return null
}
